import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { toast } from "sonner";

// onUploaded receives { url, type }
export default function MediaUpload({ value, type = "image", onUploaded, onClear, label = "Upload", testid }) {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data);
      toast.success("Uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally { setLoading(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept={type === "video" ? "video/*" : "image/*"} onChange={handle} className="hidden" data-testid={`${testid}-input`} />
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            {type === "video" ? (
              <video src={mediaUrl(value)} className="h-16 w-24 object-cover rounded-lg border border-black/10 bg-black" />
            ) : (
              <img src={mediaUrl(value)} alt="preview" className="h-16 w-24 object-cover rounded-lg border border-black/10" />
            )}
            {onClear && (
              <button type="button" onClick={onClear} data-testid={`${testid}-clear`} className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-destructive text-white flex items-center justify-center">
                <X size={14} />
              </button>
            )}
          </div>
        ) : null}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={loading}
          data-testid={`${testid}-button`}
          className="flex items-center gap-2 rounded-full border border-brand-forest/20 px-4 py-2 text-sm font-medium hover:border-brand-terracotta hover:text-brand-terracotta transition-colors"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />} {value ? "Replace" : label}
        </button>
      </div>
    </div>
  );
}
